<div class="outer">
  <span class="error-code">401</span>
  <h1 class="error-msg">NOT AUTHORIZED</h1>
  <div class="info-link">
    Unfortunately, it looks like you are not yet authorized to access this section. Please click on the below link to request access.
<br>
    <a href="/" >Click here</a>
  </div>
  <!-- <div class="info-link">
    Please click on the link to request access to the pricing tool<br>
    <a href="mailto:qp659@cummins.com?cc=support.simadvisory.com&subject=Request access&body=Hi Praveen Kumar,%0D%0A%0ARequest Access Details are provided below.%0D%0AWWID's of users for Access         : wwid%0D%0AAOR (North/West/South/Canada)  : %0D%0ABusiness Justification for access   : %0D%0A%0A Kindly let me know if any more information is required.">Click here</a>
  </div> -->
  <!-- <a href="{{ url }}" class="error-link">GO TO LOGIN PAGE</a> -->
  <!-- <a  routerLink="{{url}}" class="error-link">GO TO LOGIN PAGE</a> -->
</div>
    